import { makeApiRequest } from 'actions/api';
import { GET_MENU_CATEGORIES_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

const requestIdsByMenuSlug = {};

const nextRequestId = menuSlug => {
  const requestId = (requestIdsByMenuSlug[menuSlug] || 0) + 1;
  requestIdsByMenuSlug[menuSlug] = requestId;
  return requestId;
};

export const getMenuCategories = (menuSlug, mealPlanSlug, isEasyPrep) =>
  makeApiRequest({
    requestType: GET_MENU_CATEGORIES_V3,
    method: RequestService.v3.getMenuCategories,
    params: { menuSlug, mealPlanSlug, isEasyPrep },
    metadata: { requestId: nextRequestId(menuSlug) },
  });
